import { useCallback, useEffect, useRef, useState } from 'react';
import { api } from '../api';
import { mockListHistorial } from '../data/historialMock';

/**
 * useHistorial(params)
 *
 * Listado paginado del historial global de eventos con filtros.
 *
 * ───────────────────────────────────────────────────────────────────────
 * MODO MOCK (mientras II.4.5 no esté aplicado)
 * ───────────────────────────────────────────────────────────────────────
 * USE_MOCK = true → data/historialMock.js.
 *
 * EL LUNES, tras aplicar II.4.5: const USE_MOCK = false;
 * Endpoint real (backend II.4 eventos, ampliado con scope en II.4.5):
 *
 *   GET /api/inventario/eventos?scope&event_type&slug&search&from&to&page&pageSize
 *
 *   Respuesta: { data:[...], pagination:{page,pageSize,total} }
 *   El backend debería devolver además los conteos por scope para las
 *   tabs (o se piden aparte). Mientras, en mock vienen en `counts`.
 * ───────────────────────────────────────────────────────────────────────
 */

const USE_MOCK = false;
const wait = (ms) => new Promise((r) => setTimeout(r, ms));

export function useHistorial(params) {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 25, total: 0 });
  const [counts, setCounts] = useState({ todos: 0, interno: 0, colab: 0 });
  const [allFiltered, setAllFiltered] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const reqId = useRef(0);

  const key = JSON.stringify(params);

  const load = useCallback(async () => {
    const myReq = ++reqId.current;
    setLoading(true);
    setError(null);
    try {
      let result;
      if (USE_MOCK) {
        await wait(220);
        result = mockListHistorial(params);
      } else {
        result = await api.get('/eventos', params);
      }
      if (myReq !== reqId.current) return;
      setData(result.data || []);
      setPagination(result.pagination || { page: 1, pageSize: 25, total: 0 });
      if (result.counts) setCounts(result.counts);
      setAllFiltered(result._allFiltered || result.data || []);
    } catch (err) {
      if (myReq === reqId.current) setError(err);
    } finally {
      if (myReq === reqId.current) setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    data,
    pagination,
    counts,
    allFiltered,
    loading,
    error,
    refresh: load,
    isMock: USE_MOCK,
  };
}
